import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostDateInterface } from 'common/types/entities/BlogPostDateInterface'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import {
  generateHtmlAttrId,
  generateId,
} from 'src/shared/entities/utils/generate-base-entity'

export function createBlogPostDate(
  parentId: string,
  masterBlockId?: MasterBlockId,
): BlogPostDateInterface {
  const blogPostDate: BlogPostDateInterface = {
    id: generateId(),
    type: EntityTypeEnum.BlogPostDate,
    parentId: parentId,
    fontSize: 16,
    color: 'rgba(0, 0, 0, 1)',
    mobileFontSize: 16,
    alignSelf: 'left',
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    appearance: {
      desktop: true,
      mobile: true,
    },
    htmlAttrId: generateHtmlAttrId(EntityTypeEnum.BlogPostDate),
  }

  if (masterBlockId) {
    blogPostDate.masterBlockId = masterBlockId
  }

  return blogPostDate
}
